import { Btn, Eyebrow, PageHero } from "@/components/site/bits";
import { Reveal } from "@/components/site/Reveal";
import { BOOK, BOOK_URL, IMAGES } from "@/data/site";

const highlights = [
    "A Neuro-Clinical-Spiritual framework for understanding addiction",
    "How addictive cycles form — and how they can be broken",
    "The role of the subconscious mind, triggers, and behavioral patterns",
    "Restoring the power of choice through faith, knowledge, and support",
];

export default function PublishedWork() {
    return (
        <main>
            <PageHero
                testid="published-hero"
                eyebrow="Published Work"
                title="Breaking the Chains"
                sub="A Neuro-Bio-Spiritual Path to Freedom — the book at the heart of the NCS Framework."
                image={IMAGES.bookBg}
            />
            <section className="bg-white">
                <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 py-20 sm:py-24 lg:grid-cols-[auto_1.4fr]">
                    <Reveal className="flex justify-center">
                        <img
                            src={BOOK.cover}
                            alt="Breaking the Chains — A Neuro-Bio-Spiritual Path to Freedom, book cover"
                            data-testid="published-book-cover"
                            className="w-56 rounded-md shadow-[0_35px_70px_-25px_rgba(8,22,42,0.6)] transition-transform duration-500 hover:-translate-y-2 sm:w-64"
                        />
                    </Reveal>
                    <Reveal delay={0.12}>
                        <Eyebrow>The Book</Eyebrow>
                        <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-[#0B1F3A]">
                            {BOOK.title}
                        </h2>
                        <p className="mt-1 text-lg font-semibold text-[#C9A227]">{BOOK.subtitle}</p>
                        <p className="mt-5 max-w-2xl text-base leading-relaxed text-[#4A5568]">
                            A Neuro-Clinical-Spiritual Framework for Breaking Addictive Cycles and Restoring the Power
                            of Choice. Drawing on years of counseling, education, and ministry, Dr. Sergio Jaquez
                            offers a compassionate, practical guide for anyone seeking to understand addiction — and a
                            way forward.
                        </p>
                        <ul className="mt-6 space-y-2.5">
                            {highlights.map((h, i) => (
                                <li key={i} className="flex items-start gap-3 text-sm sm:text-base text-[#1A202C]">
                                    <span className="mt-2 h-1.5 w-1.5 shrink-0 rotate-45 bg-[#C9A227]" />
                                    {h}
                                </li>
                            ))}
                        </ul>
                        <div className="mt-8 flex flex-wrap gap-4">
                            <Btn testid="published-buy-book-btn" href={BOOK_URL} cart>
                                Buy the Book
                            </Btn>
                            <Btn variant="outlineNavy" testid="published-learn-more-btn" to="/published-work/breaking-the-chains">
                                Learn More About the Book
                            </Btn>
                        </div>
                    </Reveal>
                </div>
            </section>
        </main>
    );
}
